import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useStageAction } from './useStageAction';

export function ShuffleAcrossButton({
  eventSlug,
  stageCount,
  projectCount,
}: {
  eventSlug: string;
  stageCount: number;
  projectCount: number;
}) {
  const [open, setOpen] = useState(false);
  const { pending, error, run } = useStageAction();

  const submit = () =>
    run('post', `/admin/${eventSlug}/stages/shuffle`, {}, () => setOpen(false));

  const disabled = stageCount < 1 || projectCount < 1;
  const perStage = stageCount > 0 ? Math.floor(projectCount / stageCount) : 0;
  const remainder = stageCount > 0 ? projectCount % stageCount : 0;

  return (
    <>
      <Button
        className="rounded-none"
        variant="outline"
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        Shuffle across stages
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none">
          <DialogHeader>
            <DialogTitle>Shuffle all projects across stages?</DialogTitle>
            <DialogDescription>
              This randomly redistributes all {projectCount} projects across the{' '}
              {stageCount} stage{stageCount === 1 ? '' : 's'} (
              {remainder === 0
                ? `${perStage} per stage`
                : `${perStage}–${perStage + 1} per stage`}
              ). Existing assignments and the currently-presenting flag are
              wiped. There's no undo.
            </DialogDescription>
          </DialogHeader>

          {error && (
            <p className="bg-destructive/10 p-2 text-destructive text-sm">
              {error}
            </p>
          )}

          <div className="mt-2 flex justify-end gap-2">
            <Button
              className="rounded-none"
              variant="outline"
              onClick={() => setOpen(false)}
              disabled={pending}
            >
              Cancel
            </Button>
            <Button
              className="rounded-none"
              onClick={submit}
              disabled={pending}
            >
              {pending ? 'Shuffling…' : 'Shuffle'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
